import React from "react";
import clsx from "clsx";
import styles from "./FormRow.module.scss";

export interface FormRowProps {
  columns: "1" | "2" | "3";
}

export const FormRow: React.FC<React.PropsWithChildren<FormRowProps>> = ({
  columns = "1",
  children
}) => {
  return (
    <div
      className={clsx(styles.row, {
        [styles.col1]: columns == "1",
        [styles.col2]: columns == "2",
        [styles.col3]: columns == "3"
      })}
    >
      {children}
    </div>
  );
};
